export default __webpack_public_path__ + "static/media/survey4.44484fdd.svg";